const appendParams = (params, source) => {
    if (!source) return;

    if (source instanceof URLSearchParams) {
        source.forEach((value, key) => {
            params.append(key, value);
        });
        return;
    }

    if (typeof source === 'object') {
        Object.entries(source).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                params.append(key, value);
            }
        });
        return;
    }

    if (typeof source === 'string') {
        const normalized = source.trim().replace(/^[?&]+/, '');
        if (!normalized) return;
        const extraParams = new URLSearchParams(normalized);
        extraParams.forEach((value, key) => {
            params.append(key, value);
        });
    }
};

const getStoredUserData = () => {
    const rawData = localStorage.getItem('userData');
    if (!rawData) return null;

    try {
        return JSON.parse(rawData);
    } catch (error) {
        localStorage.removeItem('userData');
        return null;
    }
};

export const URL = function (url, filtros = '') {
    const normalizedUrl = typeof url === 'string'
        ? url.trim().replace(/\/+$/, '')
        : url;

    const userData = getStoredUserData();
    const timestamp = Date.now();
    const params = new URLSearchParams();

    if (userData && Number(userData.expire_time) >= timestamp) {
        const { token, account_id, group_id } = userData;

        if (token) params.append('token', token);
        if (account_id) params.append('account_id', account_id);
        if (group_id !== null && group_id !== undefined && Number(group_id) >= 0) {
            params.append('group_id', group_id);
        }
    } else if (userData) {
        localStorage.removeItem('userData');
    }

    appendParams(params, filtros);

    const queryString = params.toString();
    if (!queryString) return normalizedUrl;

    const hasQuery = normalizedUrl.includes('?');
    const separator = hasQuery ? (/[?&]$/.test(normalizedUrl) ? '' : '&') : '?';
    return `${normalizedUrl}${separator}${queryString}`;
};